/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ActivityReactionDto } from '../../models/activity-reaction-dto';

export interface GetReactions$Params {
  id: number;
  sinceDate?: string;
}

export function getReactions(http: HttpClient, rootUrl: string, params: GetReactions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ActivityReactionDto>>> {
  const rb = new RequestBuilder(rootUrl, getReactions.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('sinceDate', params.sinceDate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ActivityReactionDto>>;
    })
  );
}

getReactions.PATH = '/api/activities/{id}/reactions';
